module.exports = __webpack_public_path__ + "media/application/images/process_steps/mobile_bookstack_02-42786ef58ff7ff1d262162f6e98cd7ef.png";